// Ozera sticky cart. Opens Dawn's cart drawer, and keeps its count in sync by watching
// #cart-icon-bubble — which Dawn re-renders on every cart change. Watching the DOM rather
// than importing Dawn's pub/sub keeps this independent of Dawn internals across updates.
(function () {
  var bubble = document.getElementById('cart-icon-bubble');
  var sticky = document.querySelector('[data-oz-stickycart]');
  if (!sticky) return;

  function readCount() {
    if (!bubble) return 0;
    var n = bubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    return n ? parseInt(n.textContent.trim(), 10) || 0 : 0;
  }

  function sync() {
    var count = readCount();
    var label = sticky.querySelector('[data-oz-stickycart-n]');
    if (label) label.textContent = count;
    sticky.hidden = count === 0;
    sticky.setAttribute('aria-label', 'Cart (' + count + ')');
  }

  sync();

  if (bubble && 'MutationObserver' in window) {
    new MutationObserver(sync).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  sticky.addEventListener('click', function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
  });
})();
